module.exports = __webpack_public_path__ + "img/Menu-07.a005cb30.webp";